import { render, staticRenderFns } from "./ClientExportDetails.vue?vue&type=template&id=72c9647e&"
import script from "./ClientExportDetails.vue?vue&type=script&lang=js&"
export * from "./ClientExportDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports